<template>
  <div
    class="fixed top-0 left-0 z-50 flex flex-col items-center justify-center w-full h-full bg-dark-200-translucent"
  >
    <div
      class="relative w-1/2 p-6 bg-white rounded-lg shadow-xl dark:bg-dark-800 dark:text-white"
    >
      <button
        class="absolute top-0 right-0 p-4 text-dark-300 hover:text-dark-600"
        @click="$emit('close')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          class="fill-current"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </button>
      <template v-if="stage === 'form'">
        <h2 class="pb-3 text-3xl text-center font-heading">Leave a Comment</h2>
        <form @submit.prevent>
          <label for="public" class="block mt-3 font-semibold"
            >Public Comment: (Visible to All)</label
          ><input
            v-model="publicComment"
            type="text"
            name="public"
            class="inline-block w-10/12 px-4 py-2 my-2 text-center bg-transparent border-2 border-green-400 rounded outline-none focus:border-green-700 dark:text-white"
          />
          <label for="private" class="block mt-3 font-semibold"
            >Private Comment: (Only Visible to Organisers)</label
          ><input
            v-model="privateComment"
            type="text"
            name="private"
            class="inline-block w-10/12 px-4 py-2 my-2 text-center bg-transparent border-2 border-green-400 rounded outline-none focus:border-green-700 dark:text-white"
          />
          <div>
            <button v-if="!loading" class="mt-4 button" @click="saveComments">
              Submit
            </button>
            <button v-else class="mt-4 button">Loading</button>
          </div>
        </form>
      </template>
      <template v-if="stage === 'done'">
        <h2 class="pb-3 text-4xl text-center font-heading">Thanks!</h2>
        <p class="py-1">Thanks for leaving a comment!</p>
        <router-link to="/unlocked/comments" class="mt-6 button-secondary"
          >View All Comments</router-link
        >
      </template>
      <template v-if="stage === 'error'">
        <h2 class="pb-3 text-3xl text-center font-heading">
          Sorry!
        </h2>
        <p class="p-1">
          Something Went Wrong Sending Your Comments.
        </p>
        <p class="p-1">
          Feel free to email lockdownorienteering@gmail.com with any feedback.
        </p>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    user: { type: Object, default: () => ({}) },
    game: { type: String, default: '' },
  },

  data: () => ({
    privateComment: '',
    publicComment: '',
    loading: false,
    stage: 'form',
  }),

  methods: {
    saveComments: function () {
      this.loading = true
      return fetch('/api/saveComment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          raceNumber: this.user.raceNumber,
          name: this.user.name,
          game: this.game,
          privateComment: this.privateComment,
          publicComment: this.publicComment,
        }),
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText)
          else return response
        })
        .then(() => {
          this.stage = 'done'
          this.loading = false
        })
        .catch(() => {
          this.stage = 'error'
          this.loading = false
        })
    },
  },
}
</script>
